import axios from 'axios';

export const storeInstitutionInviteUser = (params) =>
    axios.post('institutions/invite-user', params)
        .then(({ data }) => data);

export const unlinkInstitution = (uuid) =>
    axios.get(`institutions/unlink/${uuid}`)
        .then(({ data }) => data);

export const unlinkUser = (uuid) =>
    axios.get(`institutions/unlink/${uuid}`)
        .then(({ data }) => data);

export const resendInstitutionInviteUser = (uuid) =>
    axios.get(`institutions/resend-invite-user/${uuid}`)
        .then(({ data }) => data);
